import { render, staticRenderFns } from "./VoteMessageDetails.vue?vue&type=template&id=5963b839&"
import script from "./VoteMessageDetails.vue?vue&type=script&lang=js&"
export * from "./VoteMessageDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports